import CustomerActionType from '../actionTypes/CustomerActionType';

const initialState = { listProduct: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case CustomerActionType.UPDATE_SELECTED_CUSTOMER:
      return { ...state, selectedCustomer: action.selectedCustomer };
    case CustomerActionType.UPDATE_ALL_CUSTOMER:
      return { ...state, allCustomers: action.allCustomers };
    case CustomerActionType.UPDATE_ALL_CUSTOMER_GROUP:
      return { ...state, allCustomerGroups: action.allCustomerGroups };
    default:
      return state;
  }
};
